import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class FuncService {
    constructor() {}

    calculatePeriodLength(length) {
        if(length >= 12) {
            length = length / 12;
        }

        return length;
    }

    displayPeriodType(length) {
        let type = null;
    
        if(length >= 12) {
          type = 'year'
        } else {
          type = 'month';
        }
    
        let nLength = this.calculatePeriodLength(length);
        if (nLength > 1) {
          type = type+'s';
        }

        return type;
      }
}